import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

import { CONFIG } from 'constants/index';

const app = !getApps().length ? initializeApp(CONFIG.firebase) : getApp();
const auth = getAuth(app);

export { app, auth };
